import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    //获取全部族谱列表
    GET_GENEALOGY_ALL(data) {
        controller='Genealogy';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_GENEALOGY_ALL", data: data }); 
    },

    //获取族谱信息详情
    GET_GENEALOGY_INFOS(data) {
        controller='Genealogy';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_GENEALOGY_INFOS", data: data }); 
    },

    //删除族谱成员信息
    DEL_GENEALOGY_MEMBER_INFOS(data) {
        controller='Genealogy';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "DEL_GENEALOGY_MEMBER_INFOS", data: data });
    },

    //新增、编辑族谱成员信息
    ADD_OR_EDIT_GENEALOGY_MEMBER(data) {
        controller='Genealogy';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "ADD_OR_EDIT_GENEALOGY_MEMBER", data: data });
    },

    //获取家庭成员信息
    GET_HOME_MEMBER_INFO(data) {
        controller='Homemember';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_HOME_MEMBER_INFO", data: data });
    },

    //新增、编辑家庭成员信息
    ADD_OR_EDIT_HOME_MEMBER(data) {
        controller='Homemember';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "ADD_OR_EDIT_HOME_MEMBER", data: data });
    },

    //获取家族成员信息列表
    GET_HOME_MEMBER_LISTS(data) {
        controller='Homemember';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_HOME_MEMBER_LISTS", data: data });
    },

    //获取全部家族成员信息
    GET_ALL_HOME_MEMBER(data) {
        controller='Homemember';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_ALL_HOME_MEMBER", data: data });
    },

    //查询产检信息列表
    GET_MEMBER_PRENATALINFO_LIST(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_MEMBER_PRENATALINFO_LIST", data: data });
    },

    //查看产检信息详情
    GET_MEMBER_PRENATALINFO_DETAILS(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_MEMBER_PRENATALINFO_DETAILS", data: data });
    },

    //查看病例类型
    GET_MEMBER_PRENATALINFO_TYPE(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_MEMBER_PRENATALINFO_TYPE", data: data });
    },

    //新增、编辑病例
    ADD_OR_EDIT_PRENATAL(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "ADD_OR_EDIT_PRENATAL", data: data });
    },

    //删除病例
    DEL_PRENATAL(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "DEL_PRENATAL", data: data });
    },

    //获取全部就医医院
    GET_ALL_HOSPITAL(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_ALL_HOSPITAL", data: data });
    },

    //获取医院列表
    GET_HOSPITAL_LIST(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_HOSPITAL_LIST", data: data });
    },

    //新增/编辑医院
    ADD_OR_EDIT_HOSPITAL(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "ADD_OR_EDIT_HOSPITAL", data: data });
    },

    //删除医院
    DEL_HOSPITAL(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "DEL_HOSPITAL", data: data });
    },

    //获取家庭成员生日信息
    GET_MEMBER_BIRTHDAY_INFOS(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_MEMBER_BIRTHDAY_INFOS", data: data });
    },

    //保存成员生日信息
    SAVE_MEMBER_BIRTHDAY(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "SAVE_MEMBER_BIRTHDAY", data: data });
    },

    //保存图片、文件信息
    SAVE_MEMBER_LIBRARY_FILE(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "SAVE_MEMBER_LIBRARY_FILE", data: data });
    },

    //获取图片、文件信息
    GET_MEMBER_LIBRARY_LIST(data) {
        controller='Prenatal';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_MEMBER_LIBRARY_LIST", data: data });
    },

}